<template>
  <Wrapper
    ref="wrapper"
    type-list="requests"
    :item-source="fetchFriendRequests"
    :popover-position-target="popoverPositionTarget"
    :popover-items="items"
    :dummy-props="{
      headerText: $t(
        '_web_account-list_dummy_friends-requests',
        'You have no friendship requests at the moment'
      ),
      text: $t(
        '_web_account-list_dummy_friends-requests_subheader',
        'We believe that they will appear soon'
      ),
    }"
    @hidePopover="popoverPositionTarget = null"
  >
    <ListItemAccount
      v-if="!user.isHidden"
      :key="user.login"
      slot-scope="{ user }"
      v-bind="{
        type: user.type,
        avatar: user.avatar,
        name: $filters.displayName(user),
        accountId: user.login,
        approved: user.approved,
        vanityId: user.vanityId || user.vanity_id,
      }"
      class="mb-3 py-2 pl-5 pr-5"
    >
      <div
        v-if="account._canEdit && myAccountId !== user.login"
        slot="action"
        class="d-flex align-items-center"
      >
        <Btn
          v-if="hasAccessByPermission('addToFriend')"
          class="h-mr-3 btn-secondary-simple"
          :label="friendAcceptText(user)"
          :loading="user.isLoading"
          @click.prevent="friendAccept(user)"
        />
        <ThreeDots
          :items="items"
          class="cursor-pointer px-3 py-4"
          @click="event => dotsClickHandler(event, user)"
        />
      </div>
    </ListItemAccount>
  </Wrapper>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { friendRequest /*report*/ } from '@/mixins/accountActions/profile';
import Btn from '@/components/atoms/HeraFormBtn';
import ListItemAccount from '@/components/common/ListItemAccount';
import Wrapper from '../ListWrapper';
import ThreeDots from '@/components/common/ThreeDots';

export default {
  name: 'AccountRequests',
  components: {
    ListItemAccount,
    Wrapper,
    Btn,
    ThreeDots,
  },
  mixins: [friendRequest /*report*/],
  data() {
    return {
      items: [],
      popoverPositionTarget: null,
    };
  },
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['hasAccessByPermission']),
  },
  methods: {
    ...mapActions(['fetchFriendRequests']),
    getAccountSocial(user) {
      const social = user.social_metadata || {};

      return {
        isFollow: social.is_follow,
        isFriend: social.is_friend,
        isFriendRequested: social.is_friend_requested,
        isFriendRequestedBy: social.is_friend_requested_by,
      };
    },
    friendAcceptText(user) {
      return this.friendRequestProfileText({
        socials: this.getAccountSocial(user),
        accountId: user.login,
        accountType: user.type,
      });
    },
    friendAccept(user) {
      this.$set(user, 'isLoading', true);
      this.friendAcceptRequestProfileAction({
        socials: this.getAccountSocial(user),
        accountType: user.type,
        accountId: user.login,
      }).then(addedToFriend => {
        this.$set(user, 'isHidden', true);
        this.$refs.wrapper.pingScroll();
        if (addedToFriend) {
          this.account.updateCounters({
            friends: +1,
          });
        }
      });
    },
    dotsClickHandler(event, user) {
      this.popoverPositionTarget = event.target;
      this.items = [
        {
          label: this.friendRequestProfileText({
            socials: this.getAccountSocial(user),
            accountId: user.login,
            accountType: user.type,
            isDeclineRequest: true,
          }),
          action: () =>
            this.friendRequestProfileAction({
              socials: this.getAccountSocial(user),
              accountId: user.login,
              accountType: user.type,
              isDeclineRequest: true,
            }).then(() => {
              this.$set(user, 'isHidden', true);
              this.popoverPositionTarget = null;
              this.$refs.wrapper.pingScroll();
            }),
          loading: this.waitingFriendRequest,
        },
      ];
    },
  },
};
</script>
